/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.19.0
 * @since 1.19.0
 */

import { IWizardMultiSearchReducer } from './reducer';

export enum EWizardMultiSearchSteps {
    Selection = 'MsisdnDocumentSelectionStep',
    Confirm = 'ConfirmSelectionStep',
}

export const initWizardMultiSearchState: IWizardMultiSearchReducer = {
    validation: {
        isValid: true,
        error: '',
    },
    // step selection
    maxRows: 0,
    templateUrl: '',
    // attach file
    fileIsLoading: false,
    fileName: '',
    // step confirm
    foundMsisdnsCount: 0,
    notFoundMsisdnsCount: 0,
    // subscriber lists
    msisdn: [],
    msisdnHasMore: false,
    msisdnIsLoading: false,
    msisdnError: '',
    msisdnNotFound: [],
    msisdnNotFoundHasMore: false,
    msisdnNotFoundIsLoading: false,
    msisdnNotFoundError: '',
}

/*
* -------------------------------------------
*           Common Wizard Actions
* -------------------------------------------
*/

export const WIZARD_MULTI_SEARCH_HANDLE_NEXT =
    '@@b2b_portal_ui/wizardMultiSearch/WIZARD_MULTI_SEARCH_HANDLE_NEXT';

export const WIZARD_MULTI_SEARCH_SET_PARAMS =
    '@@b2b_portal_ui/wizardMultiSearch/WIZARD_MULTI_SEARCH_SET_PARAMS';

export const WIZARD_MULTI_SEARCH_START_VALIDATE =
    '@@b2b_portal_ui/wizardMultiSearch/WIZARD_MULTI_SEARCH_START_VALIDATE';
export const WIZARD_MULTI_SEARCH_SET_STEP_VALID =
    '@@b2b_portal_ui/wizardMultiSearch/WIZARD_MULTI_SEARCH_SET_STEP_VALID';

/*
* -------------------------------------------
*          ATTACH FILE
* -------------------------------------------
*/

export const WIZARD_MULTI_SEARCH_ATTACH_FILE =
    '@@b2b_portal_ui/wizardMultiSearch/WIZARD_MULTI_SEARCH_ATTACH_FILE';
export const WIZARD_MULTI_SEARCH_ATTACH_FILE_SUCCESSFUL =
    '@@b2b_portal_ui/wizardMultiSearch/WIZARD_MULTI_SEARCH_ATTACH_FILE_SUCCESSFUL';
export const WIZARD_MULTI_SEARCH_ATTACH_FILE_FAILED =
    '@@b2b_portal_ui/wizardMultiSearch/WIZARD_MULTI_SEARCH_ATTACH_FILE_FAILED';

/*
* -------------------------------------------
*          Subscriber List
* -------------------------------------------
*/

export const WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST =
    '@@b2b_portal_ui/wizardMultiSearch/WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST';
export const WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_SUCCESSFUL =
    '@@b2b_portal_ui/wizardMultiSearch/WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_SUCCESSFUL';
export const WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_FAILED =
    '@@b2b_portal_ui/wizardMultiSearch/WIZARD_MULTI_SEARCH_GET_SUBSCRIBER_LIST_FAILED';
